<template>
  <section class="c-section c-section--certificate py-5">
    <div class="container">
      <b-skeleton-wrapper :loading="isLoading">
        <template #loading>
          <div class="row gx-4">
            <div class="col-12 col-lg-6">
              <b-skeleton
                no-aspect
                animation="fade"
                class="light mb-2"
                height="50px"
              ></b-skeleton>
              <b-skeleton
                no-aspect
                animation="fade"
                class="light mb-2"
                height="20px"
                width="80%"
              ></b-skeleton>
              <b-skeleton
                no-aspect
                animation="fade"
                class="light mb-5"
                height="20px"
                width="70%"
              ></b-skeleton>
              <b-skeleton
                no-aspect
                animation="fade"
                class="light mb-2"
                height="20px"
                width="50%"
              ></b-skeleton>
              <b-skeleton
                no-aspect
                animation="fade"
                class="light mb-2"
                height="20px"
                width="70%"
              ></b-skeleton>
            </div>
            <div class="col-12 col-lg-6 d-none d-lg-block">
              <b-skeleton-img
                aspect="16:9"
                animation="fade"
                class="light"
              >
              </b-skeleton-img>
            </div>
          </div>
        </template>

        <div v-if="body" class="row gx-4">
          <div class="col-12 col-lg-6">
            <h1 class="fs-30 w-black c-section__text">Tu certificado está listo</h1>
            <p class="mb-5 c-section__text">
              De parte de todo el equipo Arcux felicitamos tu esfuerzo.
              <span class="w-bold">¡Sigue aprendiendo todos los días!</span>
            </p>

            <div class="mb-5 d-lg-none">
              <div class="bg-white p-2 br--medium ax-shadow--medium">
                <figure>
                  <img
                    class="w-100 of--contain"
                    src="@/assets/images/home/certificate.png"
                    alt=""
                  />
                </figure>
              </div>
              <div class="d-flex justify-content-end mt-3">
                <a href="" class="c-link c-link--primary d-flex align-items-center">
                  <Icon icon="material-symbols:download-rounded" class="fs-21 me-2" />
                  Descargar certificado
                </a>
              </div>
            </div>

            <div class="c-section__share mb-5">
              <p>
                Comparte tu certificado a cualquier red social y da a conocer
                tus habilidades al mundo.
                <span class="w-bold">¡Celebra tus logros!</span>
              </p>
              <div class="c-social-media d-flex">
                <a
                  :href="getSocialMediaShare('facebook')"
                  class="c-social-media__social c-social-media__social--facebook me-2"
                  target="_blank"
                >
                  <i class="icon-facebook d-flex align-items-center fs-18"></i>
                </a>
                <a
                  :href="getSocialMediaShare('twitter')"
                  class="c-social-media__social c-social-media__social--twitter me-2"
                  target="_blank"
                >
                  <i class="icon-twitter d-flex align-items-center fs-18"></i>
                </a>
                <a
                  :href="getSocialMediaShare('linkedin')"
                  class="c-social-media__social c-social-media__social--linkedin me-2"
                  target="_blank"
                >
                  <i class="icon-linkedin d-flex align-items-center fs-18"></i>
                </a>
                <a
                  :href="getSocialMediaShare('whatsapp')"
                  class="c-social-media__social c-social-media__social--whatsapp me-2"
                  target="_blank"
                >
                  <i class="icon-whatsapp d-flex align-items-center fs-18"></i>
                </a>
                <CopyToClipboard :certificate="$route.params.certification_id" />
              </div>
            </div>

            <div v-if="body.course" class="c-card-recommend-course bg-white ax-shadow--medium">
              <div class="p-3">
                <div class="d-flex flex-column flex-md-row">
                  <div class="mb-3 me-md-3">
                    <figure class="c-card-recommend-course__cover br--small overflow-hidden">
                      <img
                        class="w-100 of--contain"
                        :src="body.course.thumbnail"
                        :alt="`Arcux - ${body.course.post_title}`"
                      />
                    </figure>
                  </div>
                  <div>
                    <h4 class="w-bold fs-16">
                      {{body.course.post_title}}
                    </h4>
                    <p class="mb-0 w-medium fs-14">
                      {{body.course.post_excerpt}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="c-hr bg-light-gray"></div>
              <div v-if="body.course.teacher" class="p-3 d-flex justify-content-between">
                <div class="d-flex">
                  <div class="c-avatar c-avatar--extra-tiny">
                    <figure class="c-avatar__image me-2 overflow-hidden">
                      <img
                        :src="body.course.teacher.avatar"
                        :alt="`Arcux - ${body.course.teacher.fullname}`"
                      />
                    </figure>
                  </div>
                  <p class="mb-0 w-medium">
                    {{body.course.teacher.fullname}}
                  </p>
                </div>
                <a
                  :href="body.course.url"
                  class="c-link c-link--primary"
                >
                  Tomar curso
                </a>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 d-none d-lg-block">
            <div class="bg-white p-2 br--medium ax-shadow--medium">
              <figure>
                <img
                  class="w-100 of--contain"
                  :src="`${body.certificate.path}.jpg`"
                  :alt="`Arcux Certificado - ${body.student.display_name}`"
                />
              </figure>
            </div>
            <div class="d-flex justify-content-end mt-3 mb-5">
              <a
                :href="`${body.certificate.path}.pdf`"
                download
                target="_blank"
                class="c-link c-link--primary d-flex align-items-center"
              >
                <Icon icon="material-symbols:download-rounded" class="fs-21 me-2" />
                Descargar certificado
              </a>
            </div>
          </div>
        </div>
      </b-skeleton-wrapper>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      body: null,

      isLoading: false,
    };
  },
  components: {
    CopyToClipboard: () => import(/* webpackChunkName: "clipboard" */'@/components/exam/Clipboard.vue'),
  },
  mounted() {
    this.getCertificate();
  },
  methods: {
    getSocialMediaShare(social) {
      let baseSocial = '';

      switch (social) {
        case 'facebook':
          baseSocial = 'https://www.facebook.com/sharer/sharer.php?u=';
          break;

        case 'twitter':
          baseSocial = 'https://twitter.com/share?text=Mi nuevo logro conseguido gracias a @Arcux...&url=';
          break;

        case 'linkedin':
          baseSocial = 'https://www.linkedin.com/sharing/share-offsite/?url=';
          break;

        case 'whatsapp':
          baseSocial = 'https://api.whatsapp.com/send?text=Mi%20nuevo%20logro%20conseguido%20gracias%20a%20@Arcux..., ';
          break;

        default:
          baseSocial = '';
          break;
      }

      return `${baseSocial}${process.env.VUE_APP_SITE}/panel/certificados/${4554}`;
    },
    getCertificate() {
      this.isLoading = true;

      const url = `${process.env.VUE_APP_API_V2}/certificates/${this.$route.params.certification_id}`;

      fetch(url)
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.body = response.data;
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
